import Vue from 'vue';

export default class ViewFieldVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	name = '';
	//uiComponent = 'view-text-field';
	propertyName = '';
	fieldTypeChosen = 'textField';
	typeProperties = Vue.observable({});
	toolTip = '';
	developersOnly = false;
	accessibleAtRuntime = false;
	overridableBySharedInstances = false;
	includeFieldInSearch = true;
	
	constructor()
	{
		
	}
}